<style lang="scss">
</style>

<template>
  <div>
    <Alert type="error"
           class="color-error">
      {{$t('erp.virtualstore.descrpattention',{defaultValue:'注意事项'})}}
      <ul style="list-style-type: disc;padding-left:20px;">
        <li>{{$t('erp.virtualstore.editchannelskuedsc1',{defaultValue:'建议同项目的SKU进行复制'})}}</li>
        <li>{{$t('erp.virtualstore.editchannelskuedsc2',{defaultValue:'复制后数据直接覆盖SKU原有配置，请确认清楚再操作'})}}</li>
        <li>{{$t('erp.virtualstore.descrpattention3',{defaultValue:'最多一次复制50条'})}}</li>
      </ul>
    </Alert>
    <div class="clearfix">
      <span class="pull-left width-10per">{{$t('fbb.costmanage.explain',{defaultValue:'说明'})}}:</span>
      <Input class="pull-left width-90per"
             :rows="4"
             v-model="skus"
             type="textarea"
             :placeholder="$t('erp.virtualstore.manysku',{defaultValue:'多个SKU,换行分隔'})" />
    </div>
    <footer class="padding-top-15 text-right">
      <Button type="primary"
              class="width-15per"
              @click="submit">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
      <Button class="width-15per"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </div>
</template>

<script>
import { HttpCopyVs } from '@/service/boss/allot'
export default {
  props: ['id'],
  data () {
    return {
      loading: false,
      skus: ''
    }
  },

  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      if (!(this.skus && this.id)) {
        this.$Message.error(this.$t('global.common.enter',{defaultValue:'请输入'})+'skus');
        return;
      }
      this.loading = true;
      HttpCopyVs({ erpSku: this.skus.replace(new RegExp('\\n|\\r', 'g'), ','), id: this.id }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
        this.loading = false;
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
        this.loading = false;
      })
    }
  }
}

</script>

